const addUtmParamsToInputs = () => {
	const params = new URLSearchParams(window.location.search);
	const utmFields = [
		{ id: 9000000, key: 'utm_source' },
		{ id: 9000001, key: 'utm_medium' },
		{ id: 9000002, key: 'utm_campaign' },
		{ id: 9000003, key: 'utm_term' },
		{ id: 9000004, key: 'utm_content' },
	];

	utmFields.forEach(({ key, id }) => {
		const value = params.get(key);

		if (value) {
			const inputs = document.querySelectorAll(
				`.gfield[id*="${id}"] input`
			);

			inputs.forEach((input) => {
				if (input) {
					input.value = value;
				}
			});
		}
	});
};

const FormUTMCodes = () => {
	addUtmParamsToInputs();
};

export default FormUTMCodes;
